import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { useTranslation } from 'react-i18next';
import Hero from './components/Hero';
import TourPackages from './components/TourPackages';
import TripAdvisorReviews from './components/TripAdvisorReviews';
import ExperiencesSection from './components/ExperiencesSection';
import OurChannel from './components/OurChannel';
import { useTours } from '@/hooks/useTours';
import { useExperiences } from '@/hooks/useExperiences';
import { useHomepageReviews } from '@/hooks/useHomepageReviews';

export default function Home() {
  const { t } = useTranslation();
  const { tours, loading: toursLoading } = useTours();
  const { experiences, loading: expLoading } = useExperiences();
  const { reviews, loading: reviewsLoading } = useHomepageReviews();

  const northernExperiences = experiences.filter((e) => e.region === 'northern');
  const centralExperiences = experiences.filter((e) => e.region === 'central');
  const southernExperiences = experiences.filter((e) => e.region === 'southern');

  return (
    <div className="min-h-screen bg-white">
      <Navbar dark />
      <main>
        <Hero />
        <TourPackages tours={tours} loading={toursLoading} />
        <TripAdvisorReviews reviews={reviews} loading={reviewsLoading} />
        <ExperiencesSection
          title={t('home.northernExperiences')}
          experiences={northernExperiences}
          loading={expLoading}
        />
        <ExperiencesSection
          title={t('home.centralExperiences')}
          experiences={centralExperiences}
          bgColor="bg-background-200"
          loading={expLoading}
        />
        <ExperiencesSection
          title={t('home.southernExperiences')}
          experiences={southernExperiences}
          bgColor="bg-accent-100"
          loading={expLoading}
        />
        <OurChannel />
      </main>
      <Footer />
    </div>
  );
}